/**
 * Accordions Module
 * Handles accordion interactions
 */

import { $$, on, exists, toggleClass, removeClass, addClass, closest, find } from '../utils/dom.js';

export const initAccordion = () => {
  if (!exists(".accordion__item")) {
    return;
  }

  on($$(".accordion__item__headline"), "click", function () {
    const accordionItem = closest(this, ".accordion__item");
    if (accordionItem) {
      toggleClass(accordionItem, "active");
    }
  });
};

export const initAccordionDynamic = () => {
  if (!exists(".accordion-dynamic__accordion__item")) {
    return;
  }

  on($$(".accordion-dynamic__accordion__item"), "click", function () {
    const currentItem = this;

    removeClass(".accordion-dynamic__accordion__item", "active");
    gsap.to($$(".accordion-dynamic__accordion__item__content"), {
      opacity: 0,
      duration: 0.3,
      ease: "linear",
    });
    gsap.to($$(".accordion-dynamic__accordion__item__content"), {
      height: 0,
      duration: 0.3,
      ease: "linear",
      delay: 0.3,
    });

    addClass(currentItem, "active");
    const content = find(currentItem, ".accordion-dynamic__accordion__item__content");
    const scrollHeight = content.scrollHeight;

    gsap.to(content, {
      height: scrollHeight,
      duration: 0.3,
      ease: "linear",
      delay: 0.3,
    });
    gsap.to(content, {
      opacity: 1,
      duration: 0.3,
      ease: "linear",
      delay: 0.6,
    });
  });
};
